import React, {createRef} from 'react'
import {findDOMNode} from "react-dom"

import TextareaAutosize from "react-autosize-textarea"

type Props = {
    className?          : string
    style?              : any

    icon?               : any
    value               : string
    placeholder?        : string
    commitDelay?        : number
    rows?               : number
    rowHeight?          : number
    padding?            : number
    maxRows?            : number

    textareaClassName?  : string

    autoSaveChanges?    : boolean
    autoSaveOnBlur?     : boolean
    autoSaveOnUnmount?  : boolean
    focusOnMount?       : boolean
    selectOnFocus?      : boolean
    disabled?           : boolean
    commitOnEnter?      : boolean

    onFocus?            : func
    onBlur?             : func
    onChange?           : func
    onImmediateChange?  : func
    onEnter?            : func
    onEscape ?          : func
}

export default class EditableTextarea extends React.Component<Props, any> {

    public commited             : boolean   = true
    private debounceOnChange    : any
    private textareaRef         : any       = createRef()

    static defaultProps = {
        disabled            : false,
        commitDelay         : 600,
        rows                : 1,
        rowHeight           : 20,
        padding             : 4,

        autoSaveChanges     : false,
        autoSaveOnBlur      : true,
        autoSaveOnUnmount   : false,
        focusOnMount        : false
    }

    constructor(props: Props) {
        super(props);

        this.state = {
            value   : this.props.value,
            rows    : this.props.rows
        }
    }

    UNSAFE_componentWillReceiveProps(newProps: Props) {
        if (this.commited && this.state.value !== newProps.value)
            this.setState({value: newProps.value})
    }

    componentDidMount() {
        if (this.props.focusOnMount) this.focus()
        this.calculateToFit()
        this.debounceOnChange = _.debounce(this.commitOnChange, this.props.commitDelay)
    }

    componentWillUnmount() {
        this.debounceOnChange.cancel()

        if (this.props.autoSaveOnUnmount) this.commitOnChange(this.state.value)
    }

    componentDidUpdate() {
        this.calculateToFit()
    }

    calculateToFit = () => {
        const node: any = findDOMNode(this)
        const newRows = this.props.padding && this.props.rowHeight && node.scrollHeight > node.clientHeight ?
            Math.ceil((node.scrollHeight - (2 * this.props.padding)) / this.props.rowHeight)
            :
            this.state.rows

        if (this.state.rows !== newRows){
            this.setState({rows:newRows})
        }
    }

    commitOnChange = (newValue: any) => {
        this.commited = true;
        if (this.props.onChange) this.props.onChange(newValue ? newValue.trim() : newValue)
    }

    focus = () => {
        this.textareaRef.current.focus()

        const end = this.textareaRef.current.value.length
        this.textareaRef.current.setSelectionRange(end, end)
    }

    blur = () => {this.textareaRef.current.blur()}
    setCaretToEnd = () => {
        const value = !_.isNil(this.state.value) ? this.state.value : ""
        this.textareaRef.current.setSelectionRange(value.length,value.length)
    }

    onFocus = (e: React.FocusEvent) => {
        if (this.props.selectOnFocus) this.textareaRef.current.select()
        if (this.props.onFocus) this.props.onFocus(e)
    }

    onBlur = (e: React.FocusEvent) => {
        if (this.props.onBlur) this.props.onBlur(e)

        if (this.props.autoSaveChanges || this.props.autoSaveOnBlur){
            this.debounceOnChange.cancel()
            this.commitOnChange(this.state.value)
        }
    }

    onInputKeyDown = (event: React.KeyboardEvent) => {
        switch (event.key) {
            case "Enter":
                if (this.props.commitOnEnter && !event.shiftKey && !event.ctrlKey) {
                    if (this.props.onEnter) this.props.onEnter()
                    else this.textareaRef.current.blur()
                }

                if (!this.props.autoSaveChanges && !this.props.autoSaveOnBlur) this.commitOnChange(this.state.value)
                break

            case "Escape":
                event.preventDefault()
                if (this.props.onEscape) this.props.onEscape()
                break
        }
    }

    onChange = (event: any) => {
        this.commited = false
        let newValue = event.target.value

        if (this.props.autoSaveChanges) this.debounceOnChange(newValue)
        this.setState({value:newValue}, ()=>{
            if (this.props.onImmediateChange) this.props.onImmediateChange(newValue)
        })
    }

    onResize = (e: any) => {
        // console.log("EditableTextarea onResize", e);
    }

    render() {
        const classes = Classes(this.props.className, {
            empty       : _.isNil(this.state.value),
            disabled    : this.props.disabled
        })

        const Component: any = TextareaAutosize
        return (
            <div className={classes}>
                {this.props.icon}

                <Component ref          = {this.textareaRef}
                           className    = {this.props.textareaClassName}
                           style        = {this.props.style}

                           rows         = {this.state.rows}
                           spellCheck   = "false"

                           placeholder  = {this.props.placeholder}
                           value        = {!_.isNil(this.state.value) ? this.state.value : ""}
                           disabled     = {this.props.disabled}
                           onKeyDown    = {this.onInputKeyDown}
                           onFocus      = {this.onFocus}
                           onBlur       = {this.onBlur}
                           onChange     = {this.onChange}
                           onResize     = {this.onResize}/>
            </div>
        )
    }
}